// extracted by mini-css-extract-plugin
module.exports = {"submitButtons":"submitAssessment__submitButtons___3vkDN","activeButton":"submitAssessment__activeButton___12HaD"};